<template>
  <!-- 筛选标签 -->
  <div class="app-search-tag-body">
    <SearchTag ref="Assets" :tags="tags.assets.name"></SearchTag>
    <SearchTag ref="Engine" :tags="tags.engine.name"></SearchTag>
    <SearchTag ref="ContentType" :tags="tags.contentType.name"></SearchTag>
    <SearchTag ref="OpenType" :tags="tags.openType.name"></SearchTag>
  </div>
</template>

<script>

import SearchTag from "@/views/share/search/SearchTag";

export default {
  name: "SearchPlugin",
  components: {
    SearchTag
  },
  data() {
    return {
      tags: {
        assets: {
          name: "功能",
          data: [
            {
              tagName: '建模'
            },
            {
              tagName: '资产'
            },
            {
              tagName: '管理'
            },
            {
              tagName: '操作'
            },
            {
              tagName: '材质'
            }
          ]
        },
        engine: {
          name: "代理",
          data: [
            {
              tagName: '国内'
            },
            {
              tagName: '国外'
            }
          ]
        },
        contentType: {
          name: "类型",
          data: [
            {
              tagName: '视频'
            },
            {
              tagName: '文本'
            }
          ]
        },
        openType: {
          name: "开源",
          data: [
            {
              tagName: '正版代理'
            },
            {
              tagName: '开源转载'
            }
          ]
        }
      }
    }
  }
}
</script>

